import axios from 'axios';
import { getUrl } from '../service-utils';
import authHeader from '../auth-header';

const BASE = `${getUrl()}admin/dashboard`;

// ── Types ──────────────────────────────────────────────────────────────────

export interface DashboardStats {
  users: {
    total: number;
    newToday: number;
  };
  jobs: {
    queued: number;
    inProgress: number;
    failed: number;
    deadLetter: number;
  };
  errors: {
    lastHour: number;
    last24h: number;
  };
  api: {
    avgLatencyMs: number;
    requestsLastHour: number;
    serverErrorsLastHour: number;
  };
  aiCostTodayUsd: number;
  transcription: {
    successesToday: number;
    noTranscriptToday: number;
    tier1Today: number;
    tier2Today: number;
    tier3Today: number;
    avgExtractionMsToday: number;
    totalCostTodayUsd: number;
    retryRequests24h: number;
  };
  charts: {
    signupsByDay: { date: string; count: number }[];
    errorsByDay: {
      date: string;
      critical: number;
      high: number;
      medium: number;
      low: number;
    }[];
    apiVolumeByDay: { date: string; count: number; errors: number }[];
    transcriptionCostByDay: {
      date: string;
      successes: number;
      costUsd: number;
    }[];
    transcriptionTierByDay: {
      date: string;
      tier1: number;
      tier2: number;
      tier3: number;
    }[];
  };
}

// ── Service ────────────────────────────────────────────────────────────────

export const adminDashboardService = {
  async getStats(): Promise<DashboardStats> {
    const { data } = await axios.get<{ status: string; data: DashboardStats }>(
      BASE,
      { headers: authHeader() }
    );
    return data.data;
  }
};
